import axios from "axios";
import { REFUNDS_API_URL } from "../../../constants";
import { getUserToken } from "../../../helpers/Auth";

export const ACTIONS = {
    UPDATE_PRICEMATCH_OPTIONS_LOADING: "UPDATE_PRICEMATCH_OPTIONS_LOADING",
    UPDATE_PRICEMATCH_OPTIONS_SUCCESS: "UPDATE_PRICEMATCH_OPTIONS_SUCCESS",
    UPDATE_PRICEMATCH_OPTIONS_ERROR: "UPDATE_PRICEMATCH_OPTIONS_ERROR",
};
const updatePriceMatchOptions = (data) => async (dispatch) => {
    try {
        dispatch({
            type: ACTIONS.UPDATE_PRICEMATCH_OPTIONS_LOADING,
        });
        const res = await axios.post(`${REFUNDS_API_URL}/pricematch/options/update`, data, {
            headers: {
                Authorization: `Bearer ${getUserToken()}`,
            },
        });
        if (res.status === 200) {
            dispatch({
                type: ACTIONS.UPDATE_PRICEMATCH_OPTIONS_SUCCESS,
            });
            setTimeout(() => {
                window.location.reload();
            }, 100);
        }
    } catch (error) {
        console.log({ error, stack: error.stack });
        dispatch({
            type: ACTIONS.UPDATE_PRICEMATCH_OPTIONS_ERROR,
            payload: error.message,
        });
    }
};

export default updatePriceMatchOptions;
